import { FETCH_PACKAGE_STATISTIC, FETCH_STATISTIC, FETCH_STATISTIC_MONTH} from "../actions/types";

 const packageStatisticData = (state = "loading", action) => {
  switch (action.type) {
    case FETCH_PACKAGE_STATISTIC:
      return action.payload ;
    default:
      return state;
  }
};

const statisticData = (state = "loading", action) => {
 switch (action.type) {
   case FETCH_STATISTIC:
     if(state !== "loading") return {...state, ...action.payload}
     else return action.payload ;
   case FETCH_STATISTIC_MONTH:
     if(state !=="loading"){
       console.log(action.payload)
       state = {...state, ...action.payload}
     }
     return state ;
   default:
     return state;
 }
};


export default {
  packageStatisticData,
  statisticData,
}



// WEBPACK FOOTER //
// ./src/reducers/statisticReducer.js